import type { StockStatus } from '@/api/types';
import { Badge } from '@/components/ui/badge';

export function StockBadge({ status, stock, unit }: { status: StockStatus; stock: number; unit: string }) {
  if (status === 'out') return <Badge variant="out">Out of stock</Badge>;
  if (status === 'low') {
    return (
      <Badge variant="low">
        Low · {stock} {unit}
      </Badge>
    );
  }
  return (
    <Badge variant="ok">
      {stock} {unit}
    </Badge>
  );
}

/** Separate from stock status — a medicine can be well-stocked and still expiring. */
export function ExpiryBadge({ daysToExpiry }: { daysToExpiry: number }) {
  if (daysToExpiry < 0) return <Badge variant="expired">Expired</Badge>;
  if (daysToExpiry <= 90) return <Badge variant="expiring">{daysToExpiry}d left</Badge>;
  return null;
}
